import { render, staticRenderFns } from "./formFacebook.vue?vue&type=template&id=7edaaca2"
import script from "./formFacebook.vue?vue&type=script&lang=js"
export * from "./formFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7edaaca2')) {
      api.createRecord('7edaaca2', component.options)
    } else {
      api.reload('7edaaca2', component.options)
    }
    module.hot.accept("./formFacebook.vue?vue&type=template&id=7edaaca2", function () {
      api.rerender('7edaaca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/formNetwork/formFacebook.vue"
export default component.exports